module.exports = __webpack_public_path__ + "img/a.f0c45fe3.jpg";